export default __webpack_public_path__ + "static/avatar-kayi-sketch-1-cover-9e3054a579b2e4f87fa9da591b3f3848.png";